module.exports = "https://wrf-static.prod-my.games/promo/long-lp/img/logo-ps.064334a2.svg";